(function(){
    'use strict';

    angular
        .module('elogbooks.admin.settings')
        .controller('AdminGeneralEditSettingsController', AdminGeneralEditSettingsController);

    function AdminGeneralEditSettingsController(
        $controller,
        $state,
        $scope,
        $translate,
        messenger,
        moment,
        lodash,
        apiClient,
        settingsCollection,
        siteAssociateTypesCollection,
        assetScoreTypesCollection,
        recurrenceRulesService,
        elogsUserCollection,
        contractManager,
        elbSettings,
        module,
        modulesService,
        meridianConfigurationCollectionResponse,
        confirmationModal,
        fileTypeService
    ) {
        const settingsFields = [
            'general_logo',
            'general_opening_time',
            'general_closing_time',
            'general_tasks_generate_ahead',
            'general_audits_generate_ahead',
            'general_actions_paperwork_note_required',
            'general_actionsiteassociatetype',
            'general_auditcompletionemailassociatetype',
            'general_helpdesk_number',
            'general_global_helpdesk_number',
            'general_helpdesk_email',
            'general_tenant_emailer_reply_email',
            'general_training_link',
            'general_default_locale',
            'general_non_priority_colour',
            'general_p2p_started_at_date',
            'general_contract_manager',
            'general_inactivate_users_enabled',
            'general_inactivate_users_days',
            'general_meridian_workflow',
            'general_meridian_compliance_documents_available'
        ];

        const vm = this;
        const base = $controller('AdminEditSettingsController', {
            $state: $state,
            messenger: messenger,
            moment: moment,
            lodash: lodash,
            apiClient: apiClient,
            settingsCollection: settingsCollection,
            settingsFields: settingsFields,
            elbSettings: elbSettings,
            module: module,
            fileTypeService: fileTypeService,
            buildTabSettingFormTypes: () => ({
                'general_logo' : { type: 'image-file-property', subLabel: 'RECOMMENDED_GENERAL_LOGO', min: 1, max: 15 },
                'general_opening_time'  : { type: 'time' },
                'general_closing_time' : { type: 'time' },
                'general_tasks_generate_ahead' : { type: 'number', options: { invalid: false } },
                'general_audits_generate_ahead' : { type: 'number', options: { invalid: false } },
                'general_default_locale' : {
                    type: 'select',
                    options: [
                        {value: 'en-gb', title: $translate.instant('en-gb')},
                        {value: 'fr', title: $translate.instant('fr')},
                        {value: 'es', title: $translate.instant('es')},
                        {value: 'nl', title: $translate.instant('nl')},
                        {value: 'zh-hk', title: $translate.instant('zh-hk')},
                        {value: 'de', title: $translate.instant('de')}
                    ]
                },
                'general_global_helpdesk_number' : { type: 'text' },
                'general_helpdesk_number': { type: 'text' },
                'general_training_link' : { type: 'text', validateURL: true },
                'general_helpdesk_email' : { type: 'email', notRequired: true },
                'general_tenant_emailer_reply_email' : { type: 'email' },
                'general_actionsiteassociatetype' : { type: 'select-widget', model: null, notRequired: true },
                'general_actions_paperwork_note_required' : { type: 'checkbox' },
                'general_auditcompletionemailassociatetype' : { type: 'select-widget', model: null, notRequired: true },
                'general_meridian_workflow' : {
                    type: 'select',
                    options: [
                        { title: $translate.instant('GENERAL_MERIDIAN_WORKFLOW_DISABLED'), value: false },
                        { title: $translate.instant('GENERAL_MERIDIAN_WORKFLOW_ENABLED'), value: true }
                    ],
                    notRequired: true
                },
                'general_meridian_compliance_documents_available': { type: 'checkbox' },
                'general_non_priority_colour': { type: 'colour-picker', notRequired: false, subLabel: 'NON_PRIORITY_COLOUR' },
                'general_p2p_started_at_date': { type: 'datetime', notRequired: false },
                'general_contract_manager': { type: 'select-widget', notRequired: true },
                'general_inactivate_users_enabled' : { type: 'checkbox' },
                'general_inactivate_users_days' : { type: 'number', min: 90, notRequired: true, subLabel: 'GENERAL_INACTIVATE_USERS_DAYS_SUBLABEL', options: { invalid: false } }
            }),
            validateTabSettings: (vm) => {
                for (const key in vm.settingFormTypes) {
                    const obj = vm.settingFormTypes[key];
                    if (obj && obj.validateURL) {
                        const regex = /(http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
                        const val = vm.settingsForm[key];
                        if (val !== undefined && val !== "" && regex.exec(val) === null) {
                            obj.options = { invalid: true };
                            messenger.error('WRONG_URL_FORMAT');
                            return false;
                        }
                    }
                }
                return true;
            }
        });

        angular.extend(vm, base);

        vm.tasksModuleEnabled = modulesService.isEnabled('tasks_module');
        vm.meridianEnabled = modulesService.isEnabled('meridian');
        vm.meridianConfiguration = { invalid: false };

        if (meridianConfigurationCollectionResponse) {
            vm.meridianConfiguration.invalid = !(meridianConfigurationCollectionResponse.verifyConfig &&
                meridianConfigurationCollectionResponse.verifyConfig.hasOwnProperty('is_valid') &&
                meridianConfigurationCollectionResponse.verifyConfig.is_valid);
        }

        vm.meridianWorkflowWarning = false;

        vm.contractManagerSelected = Object.keys(contractManager).length > 0 ? {
            object: contractManager,
            href: contractManager._links.self.href,
            value: contractManager.name
        } : null;

        vm.contractManagerSelect = {
            response: elogsUserCollection,
            link: Object.keys(elogsUserCollection).length > 0 ? elogsUserCollection._links.self.href : '',
            responseKeyPath: 'users',
            required: false,
            onSelect: updateContractManager,
            onRemove: removeContractManager,
            selected: vm.contractManagerSelected
        };

        if (lodash.has(siteAssociateTypesCollection, 'siteAssociateTypes')) {
            vm.siteAssociateTypesSelect = {
                response: siteAssociateTypesCollection,
                link: siteAssociateTypesCollection._links.self.href,
                responseKeyPath: 'siteAssociateTypes',
                required: true,
                onSelect: updateSiteAssociateType
            };

            if (lodash.has(vm.settings.general_actionsiteassociatetype, 'value')) {
                const selectedAssociateType = lodash.find(siteAssociateTypesCollection.siteAssociateTypes, function(element) {
                    return element.id === vm.settings.general_actionsiteassociatetype.value;
                });

                if (typeof selectedAssociateType !== 'undefined') {
                    vm.siteAssociateTypesSelect.selected = {
                        object: selectedAssociateType,
                        href: selectedAssociateType._links.self.href,
                        value: selectedAssociateType.name
                    };
                }
            }

            // Audit completion email associate type select-widget
            siteAssociateTypesCollection.siteAssociateTypes.unshift({name:  $translate.instant('NONE_SELECTED'), id: null});

            vm.auditCompletionEmailAssociateTypesSelect = {
                response: siteAssociateTypesCollection,
                link: siteAssociateTypesCollection._links.self.href,
                responseKeyPath: 'siteAssociateTypes',
                onSelect: updateAuditCompletionEmailAssociateType,
                onRemove: clearAuditCompletionEmailAssociateType
            };

            const selectedAuditCompletionAssociateType = lodash.find(siteAssociateTypesCollection.siteAssociateTypes, function(element) {
                if (vm.settings['general_auditcompletionemailassociatetype'].value.length === 0) {
                    return element.id === null;
                }

                return element.id === vm.settings['general_auditcompletionemailassociatetype'].value;
            });

            if (typeof selectedAuditCompletionAssociateType !== 'undefined') {
                vm.auditCompletionEmailAssociateTypesSelect.selected = {
                    object: selectedAuditCompletionAssociateType,
                    value: selectedAuditCompletionAssociateType.name
                };
            }

            // Ensure form types reference our models (in case base built types beforehand)
            if (vm.settingFormTypes) {
                if (vm.settingFormTypes['general_actionsiteassociatetype']) {
                    vm.settingFormTypes['general_actionsiteassociatetype'].model = vm.siteAssociateTypesSelect;
                }
                if (vm.settingFormTypes['general_auditcompletionemailassociatetype']) {
                    vm.settingFormTypes['general_auditcompletionemailassociatetype'].model = vm.auditCompletionEmailAssociateTypesSelect;
                }
            }
        }

        // Watchers specific to General tab
        if ($state.current.name === 'dashboard.admin.settings.general-settings.edit') {
            $scope.$watch('vm.settingsForm.general_inactivate_users_enabled', function(ticked) {
                if (!ticked) {
                    vm.settingsForm.general_inactivate_users_days = vm.settings['general_inactivate_users_days'].defaultValue;
                }
            });

            if (lodash.get(meridianConfigurationCollectionResponse, 'systemLinks', []).length > 0) {
                $scope.$watch('vm.settingsForm.general_meridian_workflow', function(newValue, oldValue) {
                    if (newValue !== oldValue) {
                        vm.meridianWorkflowWarning = true;
                    }
                });
            }
        }

        // Wrap update to show confirmation when Meridian workflow is toggled
        const originalUpdate = vm.update;
        vm.update = function() {
            if (vm.meridianWorkflowWarning) {
                confirmationModal.open(
                    {
                        titleMessage: 'GENERAL_MERIDIAN_WORKFLOW_CHANGE_WARNING_TITLE',
                        bodyMessage: null,
                        htmlBodyMessage: $translate.instant('GENERAL_MERIDIAN_WORKFLOW_CHANGE_WARNING_BODY'),
                        primaryText: 'Update',
                        primaryClass: 'btn-primary',
                        secondaryText: 'Cancel'
                    }
                ).result.then(originalUpdate);
            } else {
                originalUpdate();
            }
        };

        function updateContractManager() {
            if (lodash.has(vm.settings.general_contract_manager, 'value')) {
                vm.settingsForm.general_contract_manager = vm.contractManagerSelect.selected.id;
            }
        }

        function removeContractManager() {
            vm.settingsForm.general_contract_manager = null;
        }

        function updateSiteAssociateType() {
            const associateValue = parseInt(lodash.replace(vm.siteAssociateTypesSelect.selected.href, '/siteassociatetypes/', ''));

            if (lodash.has(vm.settings.general_actionsiteassociatetype, 'value')) {
                vm.settingsForm.general_actionsiteassociatetype = associateValue;
            }
        }

        function updateAuditCompletionEmailAssociateType() {
            vm.settings['general_auditcompletionemailassociatetype'].value = parseInt(lodash.replace(vm.auditCompletionEmailAssociateTypesSelect.selected.href, '/siteassociatetypes/', ''));
            vm.settingsForm['general_auditcompletionemailassociatetype'] = vm.settings['general_auditcompletionemailassociatetype'].value;
        }

        function clearAuditCompletionEmailAssociateType() {
            vm.settingsForm['general_auditcompletionemailassociatetype'] = null;
        }
    }
})();
